<div dw-tabs-nav
  role="tablist"
  tabindex="0"
  [dwType]="dwType"
  [dwShowPagination]="dwShowPagination"
  [dwPositionMode]="tabPositionMode"
  [dwAnimated]="inkBarAnimated"
  [ngStyle]="dwTabBarStyle"
  [dwHideBar]="dwHideAll"
  [dwTabBarExtraContent]="dwTabBarExtraContent"
  [selectedIndex]="dwSelectedIndex"
  (dwOnNextClick)="dwOnNextClick.emit()"
  (dwOnPrevClick)="dwOnPrevClick.emit()">
  <div
    dw-tab-label
    role="tab"
    [style.margin-right.px]="dwTabBarGutter"
    [class.ant-tabs-tab-active]="(dwSelectedIndex == i) && !dwHideAll"
    [disabled]="tab.dwDisabled"
    (click)="clickLabel(i,tab.dwDisabled)"
    *ngFor="let tab of listOfDwTabComponent; let i = index">
    <ng-container *ngIf="tab.isTitleString; else titleTemplate">{{ tab.dwTitle }}</ng-container>
    <ng-template #titleTemplate>
      <ng-template [ngTemplateOutlet]="tab.dwTitle"></ng-template>
    </ng-template>
  </div>
</div>
<div
  class="ant-tabs-content"
  #tabContent
  [class.ant-tabs-content-animated]="tabPaneAnimated"
  [class.ant-tabs-content-no-animated]="!tabPaneAnimated"
  [style.margin-left.%]="tabPaneAnimated&&(-dwSelectedIndex*100)">
  <div dw-tab-body
    class="ant-tabs-tabpane"
    [class.ant-tabs-tabpane-active]="(dwSelectedIndex == i) && !dwHideAll"
    [class.ant-tabs-tabpane-inactive]="(dwSelectedIndex != i) || dwHideAll"
    [content]="tab.content"
    *ngFor="let tab of listOfDwTabComponent; let i = index">
  </div>
</div>